// src/components/AGTUps/services/AGTUps-product-services/subscription-service.js
import API_CONFIG from './config';

class SubscriptionService {
  constructor() {
    this.api = null;
    this.cachedStatus = null;
    this.lastCheck = null;
    this.cacheValidityPeriod = 30000; // 30 segundos
  }

  initialize({ uid }) {
    this.api = API_CONFIG.createAxiosInstance();
    this.uid = uid;
  }

  async createCheckoutSession() {
    try {
      const response = await this.api.post('/subscriptions/create-checkout-session');
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  }

  async getSubscriptionStatus() {
    // Verificar si tenemos un resultado en caché válido
    const now = Date.now();
    if (this.cachedStatus && this.lastCheck && now - this.lastCheck < this.cacheValidityPeriod) {
      console.log('Using cached subscription status');
      return this.cachedStatus;
    }

    try {
      const response = await this.api.get('/subscriptions/status');
      // Almacenar en caché
      this.cachedStatus = response.data;
      this.lastCheck = now;
      return response.data;
    } catch (error) {
      console.error('Error getting subscription status:', error);
      throw error;
    }
  }

  async cancelSubscription() {
    try {
      const response = await this.api.post('/subscriptions/cancel');
      // Invalidar caché después de cancelar
      this.cachedStatus = null;
      this.lastCheck = null;
      return response.data;
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      throw error;
    }
  }

  async verifyCheckoutSession(sessionId) {
    try {
      const response = await this.api.post('/subscriptions/verify-session', {
        sessionId
      });
      // Invalidar caché después de verificar una nueva sesión
      this.cachedStatus = null;
      this.lastCheck = null;
      return response.data;
    } catch (error) {
      console.error('Error verifying checkout session:', error);
      throw error;
    }
  }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;